import { render } from "./ApplicationDetailsReview.vue?vue&type=template&id=5088c336"
import script from "./application_details_review_component.js?vue&type=script&lang=js&external"
export * from "./application_details_review_component.js?vue&type=script&lang=js&external"

import "./ApplicationDetailsReview.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__